enum WorkSafeBcFormType {
    Form8,
    Form11
}

export { WorkSafeBcFormType };
